export const CUSTOMER_LICENSE_CONSTRAINTS = {
    licenseNumber: { maxLength: 100, label: 'License Number' },
    licenseType: { maxLength: 100, label: 'License Type' },
    stateId: { label: 'State' },
    issuedAt: { label: 'Issue Date' },
    expiresAt: { label: 'Expiration Date' },
};
//# sourceMappingURL=constraints.js.map